<div class="carousel-card">
    <div class="carousel-card-title">
        {{ titleLabelPath | labelsProvider }}
        <img
            class="icon-field"
            *ngIf="titleTooltipLabelPath"
            src="assets/images/common/info.svg"
            height="16px"
            title="{{ titleTooltipLabelPath | labelsProvider }}" />
        <div class="carousel-card-title-index">
            {{ "(" + (index + 1) + "/" + cardFieldsList.length + ")" }}
        </div>
    </div>
    <div *ngIf="cardFieldsList.length > 1" class="carousel-card-arrows">
        <img src="assets/images/arrows/empty-arrow-left.svg" (click)="prevItem()" />
        <div class="next-arrow" (click)="nextItem()">
            <img src=" assets/images/arrows/empty-arrow-right.svg" />
            <div>Next</div>
        </div>
    </div>
    <app-card-fields [cardFields]="cardFieldsList[index]"> </app-card-fields>
</div>
